module.exports = __webpack_public_path__ + "static/AW_2density-332e3b36f13af3c76162326be4cc6efc.jpg";